<template>
  <BModalForm
    ref="modal"
    v-bind="$attrs"
    :create-default-data="() => ({})"
    max-width="900px"
    @closed="$emit('closed')"
  >
    <template #title-text>
      {{ title }}
    </template>

    <template #default>
      <PassportDownloadReport
        :params="params"
        :request-params="requestParams"
      />
    </template>

    <template #footer>
      <div />
    </template>
  </BModalForm>
</template>

<script>
import BModalForm from '@/components/modals/BModalForm.vue'
import PassportDownloadReport from '../PassportDownloadReport.vue'


export default {
  name: 'PassportReportModal',
  components: {
    BModalForm,
    PassportDownloadReport,
  },
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
    requestParams: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
  },
}
</script>
